var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.02953C9.9412 5.02953 5.02956 9.94117 5.02956 16C5.02956 22.0588 9.9412 26.9705 16 26.9705C22.0588 26.9705 26.9705 22.0588 26.9705 16C26.9705 9.94117 22.0588 5.02953 16 5.02953ZM2.66669 16C2.66669 8.63619 8.63622 2.66666 16 2.66666C23.3638 2.66666 29.3334 8.63619 29.3334 16C29.3334 23.3638 23.3638 29.3333 16 29.3333C8.63622 29.3333 2.66669 23.3638 2.66669 16Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 10.5998C16.7459 10.5998 17.3504 11.2043 17.3504 11.95V16.8107C17.3504 17.5564 16.7459 18.161 16.0002 18.161C15.2545 18.161 14.65 17.5564 14.65 16.8107V11.95C14.65 11.2043 15.2545 10.5998 16.0002 10.5998Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.65 20.8603C14.65 20.1146 15.2545 19.5101 16.0002 19.5101H16.0123C16.758 19.5101 17.3625 20.1146 17.3625 20.8603C17.3625 21.606 16.758 22.2106 16.0123 22.2106H16.0002C15.2545 22.2106 14.65 21.606 14.65 20.8603Z",
    fill: "#FFCC00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastAlert);
export default __webpack_public_path__ + "static/media/Toast_Alert.c74e096cdde228a15c310ba9746c4ba0.svg";
export { ForwardRef as ReactComponent };